import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[slug]/page.js");
